import { type FeedbackType } from '../feedback.js';

export enum Platform {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
}

export enum Role {
  SYSTEM = 'system',
  USER = 'user',
  ASSISTANT = 'assistant',
}

export interface ChatMessageType {
  role: Role;
  content: string;
}

export interface Conversion {
  date: string;
  incomplete: number;
  completed: number;
}
export type Filters = Partial<{
  organizationName: string;

  // age group
  young: boolean;
  adult: boolean;
  senior: boolean;

  // ethnicity
  hispanic: boolean;
  nonhispanic: boolean;

  // gender
  male: boolean;
  female: boolean;

  // income group
  lessThanTenThousand: boolean;
  tenThousandToFiftyThousand: boolean;
  fiftyThousandToOneHundredThousand: boolean;
  oneHundredThousandToTwoHundredThousand: boolean;
  greaterThanTwoHundredThousand: boolean;

  // marital status
  single: boolean;
  married: boolean;

  // payor
  selectHealth: boolean;
  medicare: boolean;
  unitedHealthcare: boolean;
  regenceBlueCross: boolean;
  blueCrossAndBlueShield: boolean;
  cigna: boolean;
  aetna: boolean;

  // platform
  mobile: boolean;
  desktop: boolean;

  // race
  white: boolean;
  black: boolean;
  americanIndian: boolean;
  asian: boolean;
  otherPacificIslander: boolean;
  otherRace: boolean;

  // sentiment
  positive: boolean;
  negative: boolean;
}>;

export interface Feedback {
  id: string;
  feedback: FeedbackType;
  comment: string;
  previsitFormSetId: string;
  date: string;
  age: number;
  daysSinceAppointment: number;
  encounterId: string;
  ehrInformationId: string;
  state: string;
  latitude: number;
  longitude: number;
  organizationName: string;
  practiceName: string;
}

export interface Query {
  startDate: string;
  endDate: string;
  filters: Filters;
}

export interface Satisfaction {
  date: string;
  negative: number;
  positive: number;
}
